import { render, staticRenderFns } from "./time.vue?vue&type=template&id=71a98120&scoped=true"
import script from "./time.vue?vue&type=script&lang=js"
export * from "./time.vue?vue&type=script&lang=js"
import style0 from "./time.vue?vue&type=style&index=0&id=71a98120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a98120",
  null
  
)

export default component.exports